<div class="loader" *ngIf="showLoader">
  <mat-spinner color="warn"> </mat-spinner>
</div>

<!-- Error Boundary -->
<app-error-boundary></app-error-boundary>

<!-- Alert Notifications -->
<app-alert></app-alert>

<div *ngIf="!isLoginOrRegisterOrReset">
  <!-- <router-outlet name="navbar" [ngClass]="{'d-none' : isLoginOrRegisterOrReset}" (eventCollapsed)="isNavbarCollapsed($event)"></router-outlet> -->
  <app-topbar *ngIf="!hideTopbar"></app-topbar>
  <app-navbar  *ngIf="!hideNavbar"
    [ngClass]="{ 'd-none': isLoginOrRegisterOrReset }"
    (eventCollapsed)="isNavbarCollapsed($event)"
  ></app-navbar>
</div>

<div
  [attr.id]="hideNavbar ? null : 'page'"
  [ngClass]="{
    'full-screen': isLoginOrRegisterOrReset,
    'full-chat': isChat,
    collapsed: isCollapsed,
    'card-extension-page': isCardExtensionRoute,
  }"
>
  <div class="container-fluid" [ngClass]="{ 'shrink-container': isLoginOrRegisterOrReset }">
    <div class="page-surface" *ngIf="!isLoginOrRegisterOrReset && isSettings">
      <div
        class="card jh-card"
        [ngClass]="{ 'shrink-container': isLoginOrRegisterOrReset, 'full-chat': isChat }"
      >
        <router-outlet></router-outlet>
        <router-outlet name="popup"></router-outlet>
      </div>
    </div>
    <div *ngIf="isLoginOrRegisterOrReset">
      <div
        class="card jh-card"
        [ngClass]="{ 'shrink-container': isLoginOrRegisterOrReset, 'full-chat': isChat }"
      >
        <router-outlet></router-outlet>
        <router-outlet name="popup"></router-outlet>
      </div>
    </div>
    <div *ngIf="!isLoginOrRegisterOrReset && !isSettings">
      <router-outlet></router-outlet>
      <router-outlet name="popup"></router-outlet>
    </div>
    <!-- <jhi-footer *ngIf="isLoginOrRegisterOrReset"></jhi-footer> -->
  </div>
</div>

<style>
  .loader {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.3);
  }
</style>
